import type { NestedFilter } from '@@partner:types:graphql'
import { gql, useMutation } from '@apollo/client'

export interface BulkUpdateSlotInput {
  name?: string
  ts_start?: number
  ts_end?: number
  ts_start_offset?: number
  ts_end_offset?: number
  orders_capacity?: number
  position_capacity?: number
  timeout?: number
}

export interface BulkUpdateSlotsVariables {
  ids?: string[]
  filter?: NestedFilter
  newData: BulkUpdateSlotInput
}

export const GQL_MUTATION_BULK_UPDATE_SLOTS = gql`
  mutation bulkUpdateSlots($ids: [ID!], $filter: NestedFilterInput, $newData: BulkUpdateSlotInput!) {
    bulkUpdateSlots(ids: $ids, filter: $filter, newData: $newData)
  }
`

export const useMutateBulkUpdateSlots = () => {
  return useMutation<{ bulkUpdateSlots: boolean }, BulkUpdateSlotsVariables>(
    GQL_MUTATION_BULK_UPDATE_SLOTS,
    {
      refetchQueries: [ 'allSlots' ]
    }
  )
}
